import Vue from 'vue';
import bimFaceComponent from '../src/components/bimFaceComponent.vue';

const loadBimFaceComponent = (container,props) => {
  new Vue({
    render: function(h) {
      return h(bimFaceComponent, {props:props})
    }
  }).$mount(container)
}

export default loadBimFaceComponent;
